import { useContext, useEffect, useRef } from 'react'
import styles from '../../styles/index.module.css'
import Head from 'next/head'
import Script from 'next/script'
import { NativeAppSignIn } from '../../components/index/NativeAppSignIn'
import { LocationContext } from '../../context/LocationContext'
import { s3Static, sgGeoCode } from '../../utils/constants'
import { UserContext } from '../../context/UserContext'
import { HardLoadingCover } from '../../components/commons/HardLoadingCover'

export default function Home() {
    const { setLocationDetailsFromIp } = useContext(LocationContext);
    const { isCheckingLoginStatus } = useContext(UserContext)

    const videoRef = useRef();

    useEffect(() => {
        videoRef.current.play()
    }, [])

    useEffect(() => {
        setLocationDetailsFromIp(sgGeoCode)
    }, [setLocationDetailsFromIp])
  
  return (
    <>
      <Head>
        <title>Mobile App Page</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Mobile App Page for app loading"/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content="Mobile App Page"/>
        <meta property="og:description" content="Mobile App Page for app loading" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/"/>
        <meta name="twitter:title" content="Mobile App Page"/> 
        <meta name="twitter:description" content="Mobile App Page for app loading"/>
        <link rel="icon" href="/favicon.ico" />
      </Head>        
      <div className={styles.main}>     
        <div id="native-app" className="fixed w-full h-full left-0 top-0 z-30 bg-black">
            <video ref={videoRef} id="vid" className="fullsize-video-bg left-1/2 -translate-x-1/2 bottom-1/2 translate-y-1/2 opacity-50" poster={s3Static + "index.jpg"} 
                title="Request for a Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and more." muted loop playsInline>
                <source src="/video/main-least.mp4"/>
                <source src="/video/main-least.mov"/>
            </video>
            <NativeAppSignIn/>  
        </div> 
      </div>
      {isCheckingLoginStatus &&
        <HardLoadingCover/>
      }
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
